import type { AppNotification, NotificationKind } from '../api/monitor';
import { daysSince, hourMinute } from './datetime';

interface KindTone {
  /** `d` do ícone (traçado, viewBox 24). */
  icon: string;
  label: string;
}

/**
 * O ícone diz de onde veio o aviso antes de o texto ser lido: uma central com
 * três origens misturadas fica ilegível quando só o título as distingue.
 */
export const NOTIFICATION_KIND: Record<NotificationKind, KindTone> = {
  job: { icon: 'M20 12a8 8 0 1 1-2.3-5.6M20 3v4h-4', label: 'Serviço assíncrono' },
  line_sync: { icon: 'M7 2h10v20H7zM11 18h2', label: 'Linha' },
  report: { icon: 'M6 3h9l4 4v14H6zM14 3v5h5M9 12h6M9 16h6', label: 'Relatório' },
};

/** Cor do ponto: o que falhou fica vermelho mesmo depois de lido. */
export function notificationDot(notification: AppNotification): string {
  if (notification.status === 'error') return 'bg-danger-500';

  return notification.read ? 'bg-line-300' : 'bg-navy-800';
}

/** Não lida ganha fundo, como no design. */
export function notificationBackground(notification: AppNotification): string {
  return notification.read ? 'bg-white' : 'bg-surface-100';
}

/**
 * "14:32", "Ontem 09:05", "12/08 07:41".
 *
 * Hora seca no mesmo dia porque é o caso comum e o mais legível; a data volta
 * assim que "ontem" deixaria dúvida sobre qual dia foi.
 */
export function notificationTime(createdAt: string): string {
  const date = new Date(createdAt);
  const time = hourMinute(date);
  const days = daysSince(createdAt);

  if (days <= 0) return time;
  if (days === 1) return `Ontem ${time}`;

  return `${date.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })} ${time}`;
}

/** `9+` — o badge do sino não cresce com o número. */
export function unreadBadge(unread: number): string {
  return unread > 9 ? '9+' : String(unread);
}
